export default {
	API_ENDPOINT: 'https://buddyup-api.herokuapp.com/api',
	TOKEN_KEY: 'buddyup-api-token-key',
}
